export const DO_PAYMENT_POST ="/DoPayment/DoPayment"
export const DO_PAYMENT_SIGN_VOID ="/DoPayment/VoidSign"
export const DO_PAYMENT_SIGN_REFUND ="/DoPayment/RefundSign"